import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { packItems, volumes, volumesIntro } from '../data/mat';
export function WhatsInside() {
  const [active, setActive] = useState<number>(0);
  const volume = volumes[active];
  return <section id="inside" className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-291" data-mp="pujchnk5yj9w">
      <div className="mx-auto max-w-6xl" data-id="element-292" data-mp="b6ofvw31burj">
        <h2 className="mx-auto max-w-3xl text-center font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-293" data-mp="b4vb6mbzfkm6">
          Co zawiera <em className="text-red-700" data-id="element-294" data-mp="2603f5tai2gr">MATEMATYKA GOTOWA™</em>?
        </h2>

        <div className="mt-16 grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-295" data-mp="23ng0d4rizwb">
          <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-296" data-mp="75copm4ij1h8">
            {volumesIntro.title}
          </h3>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-297" data-mp="3tbrqfwbrsyzc">{volumesIntro.text}</p>
        </div>

        <div role="tablist" aria-label="Tomy" className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-5" data-id="element-298" data-mp="3ct4nypeh75yl">
          {volumes.map((item, index) => {
          const isActive = index === active;
          return <button key={item.number} type="button" role="tab" id={`volume-tab-${index}`} aria-selected={isActive} aria-controls="volume-panel" onClick={() => setActive(index)} className={`flex h-48 flex-col rounded-lg border-r-8 border-black/10 p-4 text-left shadow-xl shadow-slate-900/20 transition-[transform,opacity] duration-200 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-red-700/40 sm:h-56 lg:h-64 ${item.spine} ${isActive ? '-translate-y-2' : 'opacity-75 hover:-translate-y-1 hover:opacity-100'}`} data-id="element-299" data-mp="3luvqjldpywo8" data-mpi={index}>
                <span className="text-xs font-semibold opacity-80" data-id="element-300" data-mp="2y3gnfqe4cbbx">{item.number}</span>
                <span className="mt-1 font-serif text-2xl leading-none" data-id="element-301" data-mp="2ae4d2n721x81">{item.level}</span>
                <span className={`mt-auto border-t pt-3 text-sm font-medium leading-snug ${item.rule}`} data-id="element-302" data-mp="26csnuis3fe0d">
                  {item.title}
                </span>
              </button>;
        })}
        </div>

        <div id="volume-panel" role="tabpanel" aria-labelledby={`volume-tab-${active}`} className="mt-8 border-t border-slate-900/15 pt-10" data-id="element-303" data-mp="eazn7bzlfp04">
          <AnimatePresence mode="wait" initial={false} data-id="element-304" data-mp="j5dccwnnwzwc">
            <motion.div key={volume.number} initial={{
            opacity: 0,
            y: 6
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -6
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} className="grid gap-10 lg:grid-cols-12" data-id="element-305" data-mp="o0snvhy76jpl">
              <div className="lg:col-span-5" data-id="element-306" data-mp="5c5kd3vo62e4">
                <p className="text-sm font-semibold text-red-700" data-id="element-307" data-mp="5cxfkdlcty3v">
                  {volume.number} · {volume.level}
                </p>
                <h4 className="mt-2 font-serif text-3xl leading-tight text-slate-900 sm:text-4xl" data-id="element-308" data-mp="1gqj2ds3qrnm8">{volume.title}</h4>
                <p className="mt-4 text-lg leading-relaxed text-slate-900/80" data-id="element-309" data-mp="3193d3cpxjsvq">{volume.tagline}</p>
                <p className="mt-3 leading-relaxed text-slate-900/70" data-id="element-310" data-mp="2w97btl8mafjv">{volume.intro}</p>
              </div>
              <div className="lg:col-span-7" data-id="element-311" data-mp="2ri8po50y6n8p">
                <p className="text-sm font-semibold text-slate-900/60" data-id="element-312" data-mp="2rgxkq1vrn9g0">Zawiera</p>
                <ul className="mt-4 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-313" data-mp="2mje6h1z2iwo2">
                  {volume.items.map(entry => <li key={entry} className="flex gap-3 text-[15px] leading-snug text-slate-900/80" data-id="element-314" data-mp="2hm5pv5tkj0ox">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-700" strokeWidth={2.5} aria-hidden="true" data-id="element-315" data-mp="2dhxyt1zn18nj" />
                      {entry}
                    </li>)}
                </ul>
                <p className="mt-6 font-serif text-xl italic leading-snug text-slate-900/80" data-id="element-316" data-mp="23mwa2799y8lh">{volume.outro}</p>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="mt-24 border-t border-slate-900/15 pt-12" data-id="element-317" data-mp="1u85nukw9f44">
          <div className="grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-318" data-mp="2vlet5p6stu9w">
            <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-319" data-mp="2zn9psgdsbjhc">
              Co wyróżnia MATEMATYKĘ GOTOWĄ™?
            </h3>
            <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-320" data-mp="2ln8t7d4jyy7o">
              Materiały z matematyki na cały rok szkolny – uporządkowane i gotowe do użycia.
            </p>
          </div>
          <ul className="mt-12 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-321" data-mp="2bvkvwvlbemya">
            {packItems.map(item => {
            const Icon = item.icon;
            return <li key={item.title} data-id="element-322" data-mp="22yaib3l0ylq7">
                  <Icon className="h-6 w-6 text-red-700" strokeWidth={1.75} aria-hidden="true" data-id="element-323" data-mp="22v66bk1biloz" />
                  <h4 className="mt-4 font-serif text-2xl leading-tight text-slate-900" data-id="element-324" data-mp="27tpulr3dw9ki">{item.title}</h4>
                  <p className="mt-2 text-sm leading-relaxed text-slate-900/70" data-id="element-325" data-mp="1t15wj4v3cs9x">{item.text}</p>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}